import React from 'react'
import { Image } from 'semantic-ui-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileWord, faFile, faFileExcel, faFilePdf, faFileCsv } from '@fortawesome/free-solid-svg-icons'

class Thumbnail extends React.Component {
  isNumeric (str) {
    if (typeof str !== "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }
  getElement () {
    let index = this.props.url && this.props.url.lastIndexOf('.')
    if (!index || index < 0) {
      return (
        <Image src={this.props.src}
               style={{ imageOrientation: 'form-image', width: '50px', height: '50px' }} />
      )
    }
    let extension = this.props.url.substring(index).toLowerCase()
    if (this.isNumeric(this.props.url.substring(index+1).toLowerCase())) {
      return <Image src={this.props.src} style={{imageOrientation: 'form-image', marginTop: '5px', verticalAlign: 'middle', width: '50px', height: '50px'}} />
    }
    switch (extension) {
      case '.doc':
      case '.docx':
        return (
          <div>
            <FontAwesomeIcon style={{ width: '50px', height: '50px' }} icon={faFileWord} color={'black'} />
            <br />
          </div>
        )
      case '.jpg':
      case '.jpeg':
      case '.png':
        return <Image src={this.props.src}
                      style={{ imageOrientation: 'form-image', width: '50px', height: '50px' }} />
      case '.xlsx':
      case '.xls':
        return (
          <div>
            <FontAwesomeIcon style={{ width: '50px', height: '50px' }} icon={faFileExcel} color={'black'} />
            <br />
          </div>
        )
      case '.pdf':
        return (
          <div>
            <FontAwesomeIcon style={{ width: '50px', height: '50px' }} icon={faFilePdf} color={'black'} />
            <br />
          </div>
        )
      case '.csv':
        return (
          <div>
            <FontAwesomeIcon style={{ width: '50px', height: '50px' }} icon={faFileCsv} color={'black'} />
            <br />
          </div>
        )
      default:
        return (
          <div>
            <FontAwesomeIcon style={{ width: '50px', height: '50px' }} icon={faFile} color={'black'} />
            <br />
          </div>
        )
    }
  }

  render () {
    return (
      <a href={this.props.url ? this.props.url : this.props.src} target='_blank'>
        {this.getElement()}
        {/*<Image src={this.props.src} style={{imageOrientation: 'form-image', width: '50px', height: '50px'}} />*/}
        {/*<FontAwesomeIcon style={{width: '50px', height: '50px'}} icon={faFileWord} />*/}
      </a>
    )
  }
}

export default Thumbnail




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/thumbnail-edit/index.js